import { Regions } from '@wicadu/langscope'

import globalTranslations from '@translations/ui/auth-call-to-action/global.json'

export const AUTH_CALL_TO_ACTION_TRANSLATIONS = {
  [Regions.Global]: globalTranslations,
} as const
